const AuthLayout = ({ children }) => {
  return <>{children}</>;
};

export default AuthLayout;
